import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["placeholder"]

import { computed, onMounted, PropType, ref } from 'vue';
import { ISuggestion } from '@/lib';
import { BaseIcon } from '@/lib/components/Icon';
import SearchSelectItem from './SearchSelectItem.vue';
import { i18n } from '@/i18n/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSelect',
  props: {
  modelValue: {
    type: Array as PropType<ISuggestion[]>,
    default: () => []
  },
  list: {
    type: Array as PropType<ISuggestion[]>,
    default: () => []
  },
  placeholder: {
    type: String,
    default() {
      return i18n.global.t('platform.common.search');
    }
  },
  label: {
    type: String,
    default: ''
  },
  isOpen: {
    type: Boolean,
    default: true
  },
  absolute: {
    type: Boolean,
    default: false
  },
  dark: {
    type: Boolean,
    default: false
  },
  filter: {
    type: Boolean,
    default: true
  }
},
  emits: ["focus", "add", "update:modelValue", "remove", "search", "scrolled"],
  setup(__props, { emit }: { emit: ({
  (e: 'focus'): void;
  (e: 'add', item: ISuggestion): void;
  (e: 'update:modelValue', value: ISuggestion[]): void;
  (e: 'remove', id: string): void;
  (e: 'search', search: string): void;
  (e: 'scrolled'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const search = ref(null);
const input = ref(null);
const list = ref(null);

const searchValue = ref('');
const width = ref('max-content');

const filteredList = computed(() => searchValue.value.length && props.filter
  ? props.list.filter((item) => item.label.toLowerCase().trim().includes(searchValue.value.toLowerCase().trim()))
  : props.list);

onMounted(() => {
  width.value = `${(search.value as HTMLInputElement).clientWidth}px`;
});
const isSelected = (id: string) => props.modelValue.map((v) => v.id).includes(id);
const add = (item: ISuggestion) => {
  emit('add', item);
  emit('update:modelValue', [...props.modelValue, item]);
  searchValue.value = '';
};
const remove = (id: string) => {
  const index = props.modelValue.findIndex((item) => item.id === id);
  const value = [...props.modelValue];
  value.splice(index, 1);
  emit('remove', id);
  emit('update:modelValue', value);
};
const onSearch = (value: string) => {
  emit('search', value);
  (list.value as HTMLElement).scrollTop = 0;
};
const onScroll = (ev: UIEvent) => {
  const target = ev.target as HTMLElement;
  const bottomOfTarget = target.scrollTop + target.offsetHeight >= target.scrollHeight;
  if (bottomOfTarget) {
    emit('scrolled');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'p-2': !__props.absolute }),
    style: _normalizeStyle(__props.dark ? 'background: rgba(28, 28, 28, 0.9)' : '')
  }, [
    (__props.label && __props.label.length)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass([__props.dark ? 'text-white' : 'text-gray-900', "text-base font-medium leading-tight"])
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "search",
      ref: search,
      style: _normalizeStyle(__props.dark ? 'background: rgba(0, 0, 0, 0.4)' : ''),
      class: _normalizeClass([{ border: !__props.dark, 'mt-3': __props.label && __props.label.length }, "flex flex-row items-center w-full cursor-text rounded shadow text-sm p-3"]),
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$refs.input.focus()), ["stop"]))
    }, [
      _createVNode(_unref(BaseIcon), {
        class: "text-gray-500 text-base mr-3",
        name: "search"
      }),
      _withDirectives(_createElementVNode("input", {
        ref_key: "input",
        ref: input,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
        style: {"background":"transparent"},
        class: "flex text-gray-500 focus:outline-none rounded",
        type: "text",
        placeholder: __props.placeholder,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (onSearch($event.target.value))),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus')))
      }, null, 40, _hoisted_1), [
        [_vModelText, searchValue.value]
      ])
    ], 6),
    _createElementVNode("div", {
      class: _normalizeClass(["relative w-full scrollbar-dark", { 'scrollbar-dark': __props.dark }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full rounded shadow", [
          _unref(filteredList) && _unref(filteredList).length && __props.isOpen ? 'block' : 'hidden',
          __props.absolute ? 'absolute mt-1 z-10' : ''
        ]]),
        style: _normalizeStyle(__props.dark && __props.absolute ? 'background: rgba(28, 28, 28, 0.9)' : ''),
        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", {
          ref_key: "list",
          ref: list,
          class: "whitespace-no-wrap w-full overflow-hidden overflow-y-auto rounded-lg max-h-75 mt-4",
          onScroll: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onScroll($event)), ["stop"])),
          onWheel: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredList), (item) => {
            return (_openBlock(), _createBlock(SearchSelectItem, {
              key: item.id,
              class: "w-full",
              "model-value": isSelected(item.id),
              dark: __props.dark,
              "onUpdate:modelValue": ($event: any) => ($event ? add(item) : remove(item.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["model-value", "dark", "onUpdate:modelValue"]))
          }), 128))
        ], 544)
      ], 6)
    ], 2)
  ], 6))
}
}

})